// extracted by mini-css-extract-plugin
export default {"root":"NotificationScreen_root__PV9f3","image":"NotificationScreen_image__auUWz"};